<template>
  <label
    class="block text-base leading-relaxed"
    :class="(required === true ? 'after:[content:\'*\'] after:ml-0.5 ' : '') + (variant === 'ab' ? 'font-ab-display after:text-ab-red-500 ' : 'font-display after:text-red-400 ' ) + (className !== undefined ? className : '') + (skipMarginBottoom === true ? '' : ' mb-4')"
  >{{ text }}
    <slot/>
  </label>
</template>
<script>
export default {
  name: 'input-label',
  props: {
    required: Boolean,
    text: String,
    className: String,
    variant: String,
    skipMarginBottoom: Boolean
  }
}
</script>
